import React from 'react'
import { goto } from '../../utils/url'
import EventTracker from './../../helpers/EventTracker'

export default (props) => {
    const { className, data } = props
    const { title, summary, backgroundImage, buttonText, buttonLink, icon } = data
    const buttonLinkUrl = Array.isArray(buttonLink) ? buttonLink[0] : buttonLink
    return (
        <div
            className={`block story-block ${className ? className : ''}`}
            onClick={() => {
                EventTracker.customEvent(EventTracker.EVENT_CATEGORIES.LINK_BLOCK, EventTracker.EVENT_TYPES.CLICK)
                goto(buttonLinkUrl)
            }}
        >
            <div className="block-heading">
                <img src={backgroundImage?.file?.url } alt={backgroundImage?.title} />
            </div>
            <div className="block-info">
                <div className="block-body">
                    <h4>{title}</h4>
                    <p>{summary.summary}</p>
                </div>
                <div className="block-links">
                    <span className="buttonLink read-more-link">
                        {icon && <i className={`fa ${icon} icon`} />} 
                        <span className="read-more-link-text">
                            {buttonText || 'View More'}
                        </span>
                        {!icon && <i className="fa fa-arrow-right view-more-icon" />}
                    </span>
                </div>
            </div>
        </div>
    )
}
